import { COMPANY_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import BuildObjectButton from '../../../../card/BuildObjectButton';
import { PRIMARY_ASSOCIATION_BY_OBJECT_TYPES } from '../../../../chicklets/associations/AssociationLabelConstants';
import { jsx as _jsx } from "react/jsx-runtime";
export const FlywheelDefaultCardAction = ({
  associationTypeData,
  canEditAssociation,
  canEditAssociationMessageOverride,
  createEnabledOverride,
  disabledCreateTabTooltipOverride,
  enableFlexibleAssociations = false,
  forceSingleSelectAssociation = false,
  fromObjectTypeId,
  shouldRenderCreateAndAddButton,
  toObjectTypeId,
  hasScope
}) => {
  const flexibleAssociationsGloballyEnabled = hasScope('flywheel-flexible-association-label-write');

  // If fromObjectType or toObjectType is COMPANY, we want to use primary association type ids instead of unlabeled type ids.
  // Even if there are multiple company -> deal/ticket/contact associations, all of them would be of COMPANY_TO_<TYPE>_PRIMARY_ASSOCIATION_ID
  // The Flywheel BE depends on this regardless of the not yet ungated flexible association feature.
  // Once the BE logic is updated to support unlabeled type IDs, this extra logic can be removed.
  // Related slack message: https://hubspot.slack.com/archives/CPARVEVK5/p1687952167353969?thread_ts=1686823866.383749&cid=CPARVEVK5
  const isCompanyAssociation = fromObjectTypeId === COMPANY_TYPE_ID || toObjectTypeId === COMPANY_TYPE_ID;
  const primaryAssociationTypesFromObjectType =
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  PRIMARY_ASSOCIATION_BY_OBJECT_TYPES[fromObjectTypeId];
  const associationTypeId = isCompanyAssociation && primaryAssociationTypesFromObjectType && primaryAssociationTypesFromObjectType[toObjectTypeId] || associationTypeData.associationTypeId;
  return /*#__PURE__*/_jsx(BuildObjectButton, {
    associationObjectTypeId: toObjectTypeId,
    associationTypeId: associationTypeId,
    associationCategory: associationTypeData.associationCategory,
    canEditAssociation: canEditAssociation,
    canEditAssociationMessageOverride: canEditAssociationMessageOverride,
    createEnabledOverride: createEnabledOverride,
    disabledCreateTabTooltipOverride: disabledCreateTabTooltipOverride,
    dataSeleniumTest: "flywheel-extension-build-object-button",
    dataTestId: "flywheel-extension-build-object-button",
    enableFlexibleAssociations: flexibleAssociationsGloballyEnabled || enableFlexibleAssociations,
    forceSingleSelectAssociation: forceSingleSelectAssociation,
    shouldRenderCreateAndAddButton: shouldRenderCreateAndAddButton
  });
};